import { Tag } from '@aircall/tractor-v2';
import { LineCapabilitiesIcon } from '@components/LineCapabilitiesIcon/LineCapabilitiesIcon';
import { WhatsappCapabilitiesTag } from '@components/WhatsappCapabilitiesTag/WhatsappCapabilitiesTag';
import { WhatsappRegistrationState } from '@generated/globalTypes';
import { useTranslation } from 'react-i18next';

interface NumberDetailCapabilitiesSectionProps {
  capabilities?: (string | null)[] | null;
  whatsappStatus?: WhatsappRegistrationState;
  ivr?: boolean;
  flowEditorEnabled?: boolean;
}

export function NumberDetailCapabilitiesSection({
  capabilities,
  whatsappStatus,
  ivr,
  flowEditorEnabled,
}: Readonly<NumberDetailCapabilitiesSectionProps>) {
  const { t } = useTranslation();

  return (
    <>
      <LineCapabilitiesIcon capabilities={capabilities} isNumberDetail />
      <WhatsappCapabilitiesTag capabilities={capabilities} status={whatsappStatus} />
      {ivr && !flowEditorEnabled ? (
        <Tag size='small' variant='white' mode='outline'>
          <span>{t('numbers.card.ivr_tag')}</span>
        </Tag>
      ) : null}
    </>
  );
}
